// extracted by mini-css-extract-plugin
export default {"r_l":"_505992989e ed5449ccfc","t":"_595fef169b"};